import React from 'react'
import { AppStoreLinks } from '@/config/constants'
import styles from './AppsInfo.module.scss'
import AppIcons from './AppsIcons'

interface Props {
  downloadButtons?: boolean
  image?: string
  region: string
  onAppStoreButtonClick?: (device: keyof AppStoreLinks) => void
}

const AppsInfo = ({
  downloadButtons,
  image,
  region,
  onAppStoreButtonClick,
}: Props) => (
  <div data-testid="AppsInfo">
    {downloadButtons && (
      <AppIcons region={region} onClick={onAppStoreButtonClick} />
    )}
    {image && (
      <img
        className={styles.appImage}
        src={image}
        alt=""
        data-testid="appinfo-image"
      />
    )}
  </div>
)

export default AppsInfo
